
module.exports = function(searchParams) {
  let searchPath = '';

  const paramsMapInCorrectOrder = {
    specialism: null,
    region: null,
    department: null,
    city: null,
    distance: "d",
    type: "gv",
    brand: "b",
    page: "page"
  };

  function getPrefixed(paramName) {
    let prefix = paramsMapInCorrectOrder[paramName];
    if (prefix) {
      return prefix + '-' + searchParams[paramName] + '/';
    }
    return searchParams[paramName] + '/';
  }

  for (let paramName in paramsMapInCorrectOrder) {
    if (searchParams[paramName]) {
      searchPath += getPrefixed(paramName);
    }
  }

  return searchPath;
}
